import { render, staticRenderFns } from "./Carritos.vue?vue&type=template&id=74ec9ef4&scoped=true&lang=pug"
import script from "./Carritos.vue?vue&type=script&lang=js"
export * from "./Carritos.vue?vue&type=script&lang=js"
import style0 from "./Carritos.vue?vue&type=style&index=0&id=74ec9ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ec9ef4",
  null
  
)

export default component.exports